import {BasketRuleConditionGenqlSelection} from "@/gql/gen";

export const BasketRuleConditionFields: BasketRuleConditionGenqlSelection = {
    CODE: true,
    ID: true,
    IN: true,
    MAX: true,
    MIN: true,
    NAME: true,
    NOT: true,
    TYPE: true,
    VALUE: true,
}
